import { useState, useEffect } from "react";
import { useData, useDispatch } from "./DataContext.js";

import Select from "react-select";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ToggleButton from "react-bootstrap/ToggleButton";

import FormGroup from "./FormGroup.js";
import ButtonGrid from "./ButtonGrid.js";
import AmendmentCard from "./AmendmentCard.js";

export default function AmendmentEditModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const [show, setShow] = useState(false);
    const [amendment, setAmendment] = useState(null);
    const [paragraphNum, setParagraphNum] = useState(null);
    
    useEffect(() => {
	if (gData.editAmendment === null) setShow(false);
	
	else {
	    setShow(true);
	    setParagraphNum(0);

	    // NEW AMENDMENT -> EDIT ARTICLE
	    if (gData.editAmendment.amendmentID === null && gData.editAmendment.articleID !== null)
	    {
		setAmendment({
		    amendmentID: null,
		    groupID: gData.groupID,
		    articleID: gData.editAmendment.articleID,
		    prevArticleID: gData.editAmendment.prevArticleID,
		    sessionNum: gData.editAmendment.sessionNum,
		    type: "editArticle",
		    state: "draft",
		    rank: -1,
		    content: [...gData.article[gData.editAmendment.prevArticleID].content],
		    supportIDS: [],
		    creationTime: null
		});
	    }

	    // NEW AMENDMENT -> NEW ARTICLE
	    else if (gData.editAmendment.amendmentID === null && gData.editAmendment.articleID === null)
	    {
		setAmendment({
		    amendmentID: null,
		    groupID: gData.groupID,
		    articleID: null,
		    prevArticleID: null,
		    sessionNum: gData.editAmendment.sessionNum,
		    type: "newArticle",
		    state: "draft",
		    rank: -1,
		    content: [""],
		    supportIDS: [],
		    creationTime: null
		});
	    }

	    // EDIT AMENDMENT
	    else if (gData.editAmendment.amendmentID !== null)
	    {
		const baseAmendment = gData.amendment[gData.editAmendment.amendmentID];
		setAmendment({
		    amendmentID: baseAmendment.amendmentID,
		    groupID: baseAmendment.groupID,
		    articleID: baseAmendment.articleID,
		    prevArticleID: baseAmendment.prevArticleID,
		    sessionNum: baseAmendment.sessionNum,
		    type: baseAmendment.type,
		    state: baseAmendment.state,
		    rank: baseAmendment.rank,
		    content: [...baseAmendment.content],
		    supportIDS: [...baseAmendment.supportIDS],
		    creationTime: null
		});
	    }
	}
    }, [gData.editAmendment, gData.amendment, gData.article, gData.groupID] );


    if (amendment === null) return (<></>);
    
    // ACTIONS
    function hide () { gDispatch({ type: "hideEditAmendment" }); }
    function handleHide (e) { hide(); }

    function handleAddParagraph (e)
    {
	let content = [...amendment.content];
	const num = content.length;
	content[num] = "";
	setParagraphNum(num);
	setAmendment({ ...amendment, content });
    }
    
    function handleContentChange (e)
    {
	let content = [...amendment.content];
	content[paragraphNum] = e.target.value;
	setAmendment({ ...amendment, content });
    }

    function handleSupportsChange (e) { setAmendment({ ...amendment, supportIDS: e.map((option) => option.value) }); }

    function uploadData (state = null)
    {
	const id = amendment.amendmentID;

	const data = {
	    simID: gData.simID,
	    groupID: amendment.groupID,
	    articleID: amendment.articleID,
	    prevArticleID: amendment.prevArticleID,
	    sessionNum: amendment.sessionNum,
	    type: amendment.type,
	    state: state === null ? amendment.state : state,
	    rank: amendment.rank,
	    content: amendment.content,
	    supportIDS: amendment.supportIDS
	};
	
	gDispatch({ type: "upload", table: "amendment", id, data });
	if (amendment.state === "draft") gDispatch({ type: "setAmendmentState", state: "draft", articleID: amendment.articleID, displayAll: false, amendmentID: null });
	
	hide();
    }
    
    function handleSubmit (e) { e.preventDefault(); uploadData(); }
    function handleWaitingAmendment () { uploadData("waiting"); }

    
    // SUPPORTS
    // TODO : compute globally?
    const supportOptions = Object
	.entries(gData.group)
	.filter(([id, group]) => group.simID === gData.simID && group.selected && group.groupID !== amendment.groupID && (group.type === "delegation" || group.type === "lobby"))
	.map(([id, group]) => { return { value: group.groupID, label: group.title }; });

    const supportValues = amendment.supportIDS.map((groupID) => { return supportOptions.filter((option) => option.value === groupID)[0]; });

    const supportControl = (
	<Select
	    className="w-100"
	    name="supports"
	    placeholder="Ajouter un soutien..."
	    isMulti
	    isClearable={true}
	    value={supportValues}
	    options={supportOptions}
	    onChange={handleSupportsChange}
	/>
    );
    // TODO : change colors of Select
    
    
    // PARAGRAPHS
    const paragraphButtonList = amendment.content.map((str, index) => {
	return (
	    <ToggleButton key={index} type="radio" variant="outline-primary" checked={index === paragraphNum} onClick={(e) => setParagraphNum(index)}>
		Alinéa {String.fromCharCode('a'.charCodeAt(0) + index)}
	    </ToggleButton>
	);
    });

    const newParagraphButton = (<Button variant="outline-primary" onClick={handleAddParagraph}>Nouvel alinéa</Button>);

    const paragraphButtons = (<div className="d-flex flex-row gap-2">{paragraphButtonList}{newParagraphButton}</div>)

    const paragraphControl = (
	<Form.Control autoFocus className="p-2" as="textarea" rows={4} style={{ resize: "none" }} value={amendment.content[paragraphNum]} onChange={handleContentChange}/>
    );


    // BUTTONS
    const leftButtonList = [];
    const rightButtonList = [];

    leftButtonList.push(<Button variant="outline-secondary" size="md" onClick={handleHide}>Annuler</Button>);
    if (amendment.state === "draft")
    {
	rightButtonList.push(<Button variant="primary" size="md" type="submit" form="editAmendmentForm">Enregistrer (brouillon)</Button>);
	rightButtonList.push(<Button variant="primary" size="md" onClick={handleWaitingAmendment}>Enregistrer et déposer</Button>);
    } else {
	rightButtonList.push(<Button variant="primary" size="md" type="submit" form="editAmendmentForm">Enregistrer</Button>);
    }
    
    // RENDER
    let modalTitle = "";
    let supportIDSLabel = "Liste des soutiens";
    let contentLabel = "";

    if (amendment.type === "newArticle")
    {
	modalTitle = "Rédaction d'un nouvel article";
	contentLabel = "Texte de l'article";
    }

    else if (amendment.type === "editArticle")
    {
	modalTitle = "Rédaction d'un amendement";
	contentLabel = "Texte à amender";
    }
    
    return (
	<Modal
	    size="lg"
	    show={show}
	    onHide={handleHide}
	    centered
	>
	    <Modal.Header>
		<Modal.Title>{modalTitle}</Modal.Title>
	    </Modal.Header>
	    <Modal.Body className="d-flex flex-column gap-2">
		<Form id="editAmendmentForm" onSubmit={handleSubmit} className="d-flex flex-column gap-3">

		    <FormGroup sm={3} formID="editAmendmentForm" controlId="supportIDS" label={supportIDSLabel}>
			{supportControl}
		    </FormGroup>

		    <FormGroup sm={3} formID="editAmendmentForm" controlId="content" label={contentLabel}>
			{paragraphButtons}
		    </FormGroup>

		    {paragraphControl}

		    <AmendmentCard amendment={amendment} footer={false}/>
		</Form>
	    </Modal.Body>
	    
	    <Modal.Footer>
		<ButtonGrid>
		    <ButtonGrid.Left>{leftButtonList}</ButtonGrid.Left>
		    <ButtonGrid.Right>{rightButtonList}</ButtonGrid.Right>
		</ButtonGrid>
	    </Modal.Footer>
	</Modal>
    );
}
